<template>
    <div>
        <div class="container-fluid">
            <div class="success_message" v-text="this.$root.success_message" v-if="this.$root.success_message != ''">
            </div>
            <div class="error_message" v-text="this.$root.error_message" v-if="this.$root.error_message != ''"></div>
            <div class="row">
                <div class="col-12">
                    <div class="content-pages">
                        <h2 class="page-title">Delivery Policy</h2>
                        <ul>
                            <li>We endeavor to deliver products purchased from W for Woman in excellent condition and in
                                the best possible time. </li>
                            <li>Delivery charges, delivery time & payment mode is subjected to pin code
                                <div class="check-delivery" style="display:block;margin-bottom: 10px;margin-top: 5px;">
                                    <div class="control">
                                        <label style="display:block;margin-top: 5px;margin-bottom: 0px;">Check delivery
                                            in your area:</label>
                                        <input type="text" maxlength="6"
                                            style="border: 1px solid #e4e4e4;width: 110px;border-radius: 5px;"
                                            v-model="pincode" @keyup="pin_code" class="input-text"
                                            placeholder="Enter pincode">
                                        <p class="pin-success-msg" style="font-size:12px;margin-bottom: 0px;"
                                            v-html="this.pincode_success" v-if="this.pincode_success != ''"></p>
                                        <p class="pin-error-msg" style="font-size:12px;margin-bottom: 0px;"
                                            v-html="this.pincode_error" v-if="this.pincode_error != ''"></p>
                                        <!--input type="button" class="button" value="check"-->
                                    </div>
                                </div>
                            </li>
                            <li>You can enter your pin code below to check:</li>
                            <li>It may also changes as per the availability of the logistics</li>
                            <li>Any dispute between the TCNS and the Service Provider shall be resolve by mutual
                                discussions between the authorized signatories. If the dispute remains unresolved, the
                                parties may refer such dispute to a court of law located within the jurisdiction of
                                courts in Delhi only</li>
                            <li>In case a customer returns an order after delivery, order shipping charges will not be
                                refunded. However, if you self-ship your returns, only Rs 100 will be refunded for the
                                same.</li>
                            <li>Order value is calculated after applying discounts/VAT/GST or any other applicable
                                charges.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        name: 'ship_delivery',
        metaInfo() {
            return {
                title: this.meta_title,
                meta: [
                    {
                        name: 'description',
                        content: this.meta_description
                    },
                    {
                        property: 'keywords',
                        content: this.meta_keyword
                    }
                ]
            }
        },
        data() {
            return {
                meta_title: '',
                meta_description: '',
                meta_keyword: '',
                pincode: '',
                pincode_success: '',
                pincode_error: ''
            };
        },
        methods: {
            pin_code: function () {
                let pincode = /^([0-9]{6,})+$/;
                if (this.pincode.match(pincode)) {
                    axios.get(this.$root.api_url + `/pim/pimresponse.php`, {
                        params: {
                            service: 'pincheck',
                            store: this.$root.store,
                            pincode: this.pincode,
                        }
                    })
                        .then(response => {
                            if (response.data.response.success === '1') {
                                this.pincode_success = response.data.response.success_message;
                                $cookies.set(window.location.hostname.substring(10, 4) + '_pin', this.pincode);
                                this.pincode_error = '';
                            }
                            else {
                                this.pincode_error = response.data.response.error_message;
                                this.pincode_success = '';
                            }
                        })
                }
                else {
                    this.pincode_error = "<span class='error'>Please enter valid Pin code</span>";
                    this.pincode_success = '';
                }
            },
        },
        created() {
            window.scrollTo(0, 0);
            this.pincode = $cookies.get(window.location.hostname.substring(10, 4) + '_pin');
            if (this.pincode != '') {
                this.pin_code();
            }
            this.$root.breadcrumb = 'Support';
            if (this.$root.store === 1) {
                this.meta_title = 'Delivery Policy';
                this.meta_description = 'Delivery Policy';
                this.meta_keyword = 'Delivery Policy';
            }
            else {
                this.meta_title = 'Delivery Policy';
                this.meta_description = 'Delivery Policy';
                this.meta_keyword = 'Delivery Policy';
            }
        }
    }
</script>